module.exports = __webpack_public_path__ + "static/media/guelph.0d68d522.jpg";